import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router'
import { Observable } from 'rxjs'
import { AssetService } from '../services/asset.service'
import { HttpErrorResponse } from '@angular/common/http'
import { IAsset } from '../interfaces/asset.interface'


export const assetDetailsResolver: ResolveFn<Observable<IAsset | HttpErrorResponse>> = (route: ActivatedRouteSnapshot) => {
  return inject(AssetService).getAsset(decodeURIComponent(route.paramMap.get('assetId') ?? ''))
}
